import { getOssSign } from '@/api/common';
const nanoid = require('nanoid');

const defaultConf = {
	region: 'oss-cn-hangzhou',
	//todo 是否要改名
	bucket: 'yx-resource-ali-prod',
};

const uploadOptions = {
	// 设置并发上传的分片数量。
	parallel: 5,
	// 设置分片大小。默认值为1 MB，最小值为100 KB。
	partSize: 2 * 1024 * 1024,
	// headers,
	// 自定义元数据，通过HeadObject接口可以获取Object的元数据。
};

export default class Upload {
	constructor(options) {
		this.options = { ...defaultConf, ...options };
	}
	// 初始化oss实例
	async initOssClient() {
		try {
			const accessConf = await this.getStsToken();
			const { region, bucket } = this.options;
			this.client = new OSS({
				// yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
				region,
				bucket,
				timeout: 120000, // 2min
				...accessConf,
				refreshSTSToken: async () => {
					return await this.getStsToken();
				},
				refreshSTSTokenInterval: 300000, // 5min刷一次
			});
		} catch (error) {
			console.log('初始化client oss失败', error);
			this.client = null;
		}
	}
	async getStsToken() {
		const { accessKeyId, accessKeySecret, securityToken } = await getOssSign();
		console.log(accessKeyId, accessKeySecret, securityToken,'12321')
		return {
			accessKeyId: accessKeyId,
			accessKeySecret: accessKeySecret,
			// 从STS服务获取的安全令牌（SecurityToken）。
			stsToken: securityToken,
		};
	}
	// 取消上传
	cancel() {
		this.client.cancel();
	}
	/**
	 *
	 * @param {File} file 待上传的文件
	 * @param {object} param1 上传配置信息
	 * @param {number} retryTimes 可重试上传次数
	 * @returns
	 */
	async upload(file, { progressCb, ...restOption }) {
		const uniquKey = nanoid.nanoid(16);
		let bucketUniqueFileName = `${uniquKey}-${file.name}`;
		if (file.size < uploadOptions.partSize) {
			return await this.commonUpload(file, this.options.bucketPath + bucketUniqueFileName);
		} else {
			return new Promise(async (resolve, reject) => {
				try {
					const storageKey = `${file.name}-${file.lastModified}-${file.size}`;
					const option = {
						...uploadOptions,
						...restOption,
						progress: (p, cpt, res) => {
							// 缓存记录每个断点分片信息。
							const checkpointMapInfo = {
								bucketUniqueFileName,
								cpt,
							};
							// todo 设置localstorage过期时间
							localStorage.setItem(storageKey, JSON.stringify(checkpointMapInfo));
							// 上传完成之后晴空断点信息。
							if (p * 100 == 100) {
								localStorage.removeItem(storageKey);
							}
							progressCb(p * 100);
						},
					};
					if (localStorage.getItem(storageKey)) {
						// 命中断点续传缓存
						const checkpointMapInfo = JSON.parse(localStorage.getItem(storageKey));
						bucketUniqueFileName = checkpointMapInfo.bucketUniqueFileName;
						const hasUpload = await this.checkOssHasUploads(checkpointMapInfo?.cpt?.uploadId);
						if (hasUpload) {
							// 注意：碎片过期时间是3天，如果当前断点信息无对应上面id, 则重新上传
							option.checkpoint = checkpointMapInfo.cpt;
						}
					}
					this.client
						.multipartUpload(this.options.bucketPath + bucketUniqueFileName, file, option)
						.then(res => {
							resolve(res);
						})
						.catch(e => {
							console.log(e, 777777);
							Object.keys(e).forEach(key => {
								console.log(e[key], key);
							});
							if (e.name.indexOf('ConnectionTimeoutError') > -1 || e.name.indexOf('RequestError') > -1) {
								reject({
									message: '网络超时或者中断，请检查当前网络',
									type: 'timeout',
								});
							} else if (e.name.indexOf('abort') > -1) {
								localStorage.removeItem(storageKey);
								reject({
									message: '上传过程出现异常中断，请重试',
									type: 'abort',
								});
							}
						});
				} catch (error) {
					console.log(error);
				}
			});
		}
	}
	// 普通上传
	async commonUpload(file, bucketPath) {
		return new Promise((resolve, reject) => {
			this.client
				.put(bucketPath, file)
				.then(res => {
					resolve(res);
				})
				.catch(e => {
					console.log(e, '===commonUpload====');
					if (e.name.indexOf('ConnectionTimeoutError') > -1) {
						reject({
							message: '网络超时或者中断，请检查当前网络',
							type: 'timeout',
						});
					}
				});
		});
	}
	/**
	 *
	 * @param {number} uploadId 上传文件id
	 * @returns oss上是否有对应（断点）碎片信息
	 */
	async checkOssHasUploads(uploadId) {
		try {
			const result = await this.client.listUploads({
				'max-uploads': 1,
				'upload-id-marker': uploadId,
			});
			return result.uploads?.length > 0;
		} catch (error) {
			console.log(error);
			return false;
		}
	}
	// 下载文件 后端寸bucket路径，不存完整路径，通过签名生成完整路径（实效性），防止资源盗刷
	getSignatureUrl(filePath, filename, isDownload) {
		// 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
		const response = {
			'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`,
		};
		// 填写Object完整路径。Object完整路径中不能包含Bucket名称。
		const url = this.client.signatureUrl(filePath, { response });
		if (isDownload) {
			const link = document.createElement('a');
			link.style.display = 'none';
			// 设置下载地址
			link.setAttribute('href', url);
			// 设置文件名
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			return url;
		}
	}
}
